<!-- 课程设置 -->
<template>
  <div class="app-container">
    <!--查询条件区域-->
    <!-- <div class="title-container" shadow="never">
      <div class="title-con">
        <i class="el-icon-search"></i>
        <span style="margin-left: 5px;">设置</span>
      </div>
    </div> -->
    <el-card class="operate-container" shadow="never" style="margin-top: 0px;">
      <div class="business" style="margin-top: 0px;">
        <el-form :inline="true" label-width="80px" style="margin-bottom: -20px;">
          <el-form-item label="业务名称:">
            <!-- <el-input v-model="serviceName" placeholder="请输入业务名称"></el-input> -->
            <el-select v-model="serviceName" placeholder="请选择" clearable @change="clikChange">
              <el-option v-for="item in lessList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <!--<el-form-item label="是否跨级上课:">-->
          <!--<el-switch-->
          <!--width="45"-->
          <!--@change="isLevelLessonChanged"-->
          <!--v-model="isLevelLesson"-->
          <!--active-color="#13ce66"-->
          <!--&gt;-->
          <!--</el-switch>-->
          <!--</el-form-item>-->
          <el-form-item>
            <!-- <el-button type="primary" size="medium" class="operator-btn"
                       icon="el-icon-folder-checked"
                       @click="onSetLessonNameShowDig()">{{fcLessonName}}</el-button> -->

            <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search" @click="onBtnSearch()">查
              询</el-button>
              <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search" @click="DETtnSearch()">重置</el-button>
          </el-form-item>


        </el-form>
      </div>
    </el-card>
    <!--    查询结果区域-->
    <!-- <div class="title-container" shadow="never" style="margin-top: 20px;">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">数据列表</span>
      </div>
      <div>
        <el-button type="warning" class="operator-btn2" icon="el-icon-circle-plus-outline"
          @click="handleCreateOneDlg()">新增课程</el-button>
      </div>
    </div> -->
    <div class="table-container" style="margin-top: 20px;">
      <div class="manage">
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search"
          @click="clickManage(1)">创建课程</el-button>
        <!-- <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search"
          @click="clickManage(2)">取消</el-button> -->
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search"
          @click="clickManage(3)">编辑课程</el-button>
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search"
          @click="clickManage(4)">下线</el-button>
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search"
          @click="clickManage(5)">删除</el-button>
      </div>
      <el-table :data="tableData" :header-cell-style="{ 'text-align': 'center' }" :cell-style="{ 'text-align': 'center' }"
        v-loading="listLoading" ref="seleteTable" max-height="650" border @selection-change="selectionChange">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column prop="serviceName" label="业务类型名称"></el-table-column>
        <el-table-column prop="lessonName" label="课程名"></el-table-column>
        <el-table-column prop="consumeNum" label="消耗课时"></el-table-column>
        <el-table-column prop="fitterLevelName" label="最小级别">
          <template slot-scope="scope">
            {{ scope.row | fitterLevelName }}
          </template>
        </el-table-column>
        <el-table-column prop="maxLevelName" label="最大级别">
          <template slot-scope="scope">
            {{ scope.row | fitterMaxLevelName }}
          </template>

        </el-table-column>
        <!--<el-table-column prop="levelVal" label="等级" ></el-table-column>-->
        <el-table-column prop="startMonthDes" label="最小月龄"></el-table-column>
        <el-table-column prop="endMonthDes" label="最大月龄"></el-table-column>
        <el-table-column prop="typeDes" label="类型"></el-table-column>
        <el-table-column prop="isOffLine" label="状态">
          <template slot-scope="scope">
            <div v-if="scope.row.isOffLine == 0">正常</div>
            <div v-if="scope.row.isOffLine == 1">已下线</div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="handleDeleteOne(scope.row)" type="danger" plain size="small">删除</el-button>
            <el-button @click="handleUpdateOneDlg(scope.row)" type="danger" plain size="small">修改</el-button>
          </template>
        </el-table-column> -->
      </el-table>
    </div>
    <el-dialog title="新增课程" :visible.sync="visibleDlgAdd" width="50%" center>
      <div>
        <el-form ref="registerRef" label-width="150px">
          <el-form-item label="类型:">
            <el-select v-model="createParam.type" placeholder="类型" clearable style="width: 300px;">
              <el-option v-for="item in lessList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="会员卡子类型:">
            <el-select v-model="createParam.cardSubTypeId" placeholder="会员卡子类型" clearable style="width: 300px;">
              <el-option v-for="item in subCardTypes" :key="item.id" :label="item.type" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="课程名:">
            <el-input maxlength="20" show-word-limit v-model="createParam.lessonName" placeholder=""
              style="width: 300px;"></el-input>
          </el-form-item>
          <el-form-item label="消耗课时:">
            <el-input-number :precision="1" :step="0.5" :max="999" v-model="createParam.consumeNum" placeholder=""
              style="width: 300px;"></el-input-number>
          </el-form-item>
          <el-form-item label="最小级别:" v-if="createParam.type == 2">
            <el-select v-model="createParam.levelVal" placeholder="类型" @change="onChaneLevel" clearable
              style="width: 300px;">
              <el-option v-for="item in levelOption" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="最大级别:" v-if="createParam.type == 2">
            <el-select v-model="createParam.maxLevelVal" placeholder="类型" @change="onChaneMaxLevel" clearable
              style="width: 300px;">
              <el-option v-for="item in levelOption" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="月龄范围:" v-if="createParam.type == 1">
            <el-slider v-model="createParam.month" range :marks="marks" show-stops style="width: 300px;" :max="199">
            </el-slider>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDlgAdd = false">取消</el-button>
        <el-button type="primary" @click="handleCreateOne">保存</el-button>
      </span>
    </el-dialog>
    <el-dialog title="修改课程" :visible.sync="visibleDlgUpdate" width="50%" center>
      <div>
        <el-form ref="registerRef" label-width="150px">
          <el-form-item label="类型:">
            <el-select v-model="updateParam.type" placeholder="类型" clearable style="width: 300px;">
              <el-option v-for="item in typeOption" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="会员卡子类型:">
            <el-select v-model="updateParam.cardSubTypeId" placeholder="会员卡子类型" clearable style="width: 300px;">
              <el-option v-for="item in subCardTypes" :key="item.id" :label="item.type" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="课程名:">
            <el-input maxlength="20" show-word-limit v-model="updateParam.lessonName" placeholder=""
              style="width: 300px;"></el-input>
          </el-form-item>
          <el-form-item label="消耗课时:">
            <el-input-number :precision="1" :step="0.5" :max="999" v-model="updateParam.consumeNum" placeholder=""
              style="width: 300px;"></el-input-number>
          </el-form-item>
          <el-form-item label="最小级别:" v-if="updateParam.type == 2">
            <el-select v-model="updateParam.levelVal" placeholder="类型" @change="onChaneLevelUpdate" clearable
              style="width: 300px;">
              <el-option v-for="item in levelOption" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="最大级别:" v-if="updateParam.type == 2">
            <el-select v-model="updateParam.maxLevelVal" placeholder="类型" @change="onChaneMaxLevelUpdate" clearable
              style="width: 300px;">
              <el-option v-for="item in levelOption" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="月龄范围:" v-if="updateParam.type == 1">
            <el-slider v-model="updateParam.month" range :marks="marks" show-stops style="width: 300px;" :max="199">
            </el-slider>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDlgUpdate = false">取消</el-button>
        <el-button type="primary" @click="handleUpdateOne">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog title="亲子游业务名称" :visible.sync="visibleDlgSetLessonName" width="50" center>
      <el-form ref="registerRef" label-width="150px">
        <el-form-item label="名称:">
          <el-input style="width: 300px;" v-model="fcLessonName"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="visibleDlgSetLessonName = false">取消</el-button>
        <el-button type="primary" @click="onSetLessonName">确认</el-button>
      </span>
    </el-dialog>
    <!-- // 创建课程 -->
    <el-dialog :title="dialogForms == 1 ? '创建课程' : '编辑课程'" :visible.sync="dialogFormVisible" width="30%">
      <el-form :model="form" label-width="80px">
        <el-form-item label="业务类型" style="width: 100%;" label-width="110px">
          <el-select v-model="newLevelfrom.serviceLessonId" placeholder="请选择">
            <el-option v-for="item in lessList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型">
          <el-radio-group v-model="newLevelfrom.type" @input="clickInput">
            <el-radio :label=1>月龄</el-radio>
            <el-radio :label=2>等级</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-if="newLevelfrom.type == '1'">
          <el-form-item label="min月龄">
            <el-input v-model="newLevelfrom.startMonth" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="max月龄">
            <el-input v-model="newLevelfrom.endMonth" autocomplete="off"></el-input>
          </el-form-item>
        </div>
        <div v-if="newLevelfrom.type == '2'">
          <!-- <el-form-item label="min等级">
            <el-input v-model="newLevelfrom.levelVal" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="max等级">
            <el-input v-model="newLevelfrom.maxLevelVal" autocomplete="off"></el-input>
          </el-form-item> -->
          <el-form-item label="min等级:">
            <el-select v-model="newLevelfrom.levelVal" placeholder="类型" @change="onChaneLevel" clearable
              style="width: 300px;">
              <el-option v-for="item in levelOption" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="max等级:">
            <el-select v-model="newLevelfrom.maxLevelVal" placeholder="类型" @change="onChaneMaxLevel" clearable
              style="width: 300px;">
              <el-option v-for="item in levelOption" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </div>

        <el-form-item label="课程名称">
          <el-input v-model="newLevelfrom.lessonName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="消耗课时">
          <el-input-number v-model="newLevelfrom.consumeNum" precision="1" autocomplete="off"></el-input-number>

        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button type="primary" @click="dialogForm(1)">保 存</el-button>
        <el-button @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- // 取消 -->
    <el-dialog title="取消" :visible.sync="countermand" width="30%">
      <el-form :model="form" label-width="80px">
        <el-form-item label="课程ID">
          <el-input v-model="form.date" autocomplete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="课程名称">
          <el-input v-model="form.region" autocomplete="off" disabled></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button type="primary" @click="dialogForm(2)">保 存</el-button>
        <el-button @click="countermand = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- // 下线 -->
    <el-dialog title="课程下线" :visible.sync="downline" width="30%">
      <div v-if="selectionList.length != 0 ? selectionList[0].isOffLine == 1 : ''"
        style="margin-bottom: 20px;font-size: 18px;">
        该课程已下线
      </div>
      <div v-else>
        <div style="margin-bottom: 20px;font-size: 18px;">
          是否确认下线该课程
        </div>
        <div slot="footer" class="dialog-footer" style="text-align: center;">
          <el-button type="primary" @click="dialogForm(4)">保 存</el-button>
          <el-button @click="downline = false">取 消</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- // 删除 -->
    <el-dialog title="课程删除" :visible.sync="course" width="30%">
      <div v-if="selectionList.length != 0 ? selectionList[0].isOffLine == 0 : ''"
        style="margin-bottom: 20px;font-size: 18px;">
        只能删除下线课程，已经预约课程不能删除！
      </div>
      <div v-else>
        <div style="margin-bottom: 20px;font-size: 18px;">
          该课程已下线是否确认删除该课程！
        </div>
        <div slot="footer" class="dialog-footer" style="text-align: center;">
          <el-button type="primary" @click="dialogForm(5)">保 存</el-button>
          <el-button @click="course = false">取 消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import globaldata from "../../../utils/globaldata";
import commonUtils from "../../../utils/commonUtils";
import messageUtils from "../../../utils/messageUtils";
import { delLevelLesson, newLevelLesson, updateLevelLesson, lessonsList, offLine } from "../../../api/StoreLevelLesson";
import { getCardSubTypeList, } from "../../../api/StoreLessonCard";
import {
  getFcLessonName,
  getOpenBookLevelLimit,
  setFcLessonName,
  setOpenBookLevelLimit
} from "@/api/StoreSetting";
import { qlStoreLevelLesson } from "../../../api/StoreLevelLesson";
import { EAllLevelOption } from "../../../utils/enumsUtil";

export default {
  data() {
    return {
      radio: 3,
      options: [{
        value: '选项1',
        label: '黄金糕'
      }, {
        value: '选项2',
        label: '双皮奶'
      }],
      form: {
        name: '',
        region: '',
        date: '',
      },
      selectionList: [], //列表选中数据
      lessList: [],//查询服务
      dialogFormVisible: false, // 创建 编辑
      countermand: false, // 取消
      downline: false, // 下线
      course: false, // 删除
      input: '',
      listLoading: false,
      visibleDlgAdd: false,
      visibleDlgUpdate: false,
      visibleDlgSetLessonName: false,
      //表单结果
      tableData: [
      ],
      serviceName: '',
      isLevelLesson: false,
      createParam: {
        id: null,
        lessonName: "",
        levelName: "",
        levelVal: 0,
        maxLevelVal: 0,
        month: [0, 99],
        type: "",
        consumeNum: 1,
        classroomId: "",
      },
      newLevelfrom: {
        levelName: '',
        serviceLessonId: '', // 业务类型
        type: 1,//类型
        startMonth: 0, //min月龄
        endMonth: 0, //max月龄
        levelVal: 0, // min等级
        maxLevelVal: 0,//max等级
        lessonName: '', //课程名称
        consumeNum: '', //消耗课时
      },
      updateParam: {
        id: 0,
        lessonName: "",
        levelName: "",
        levelVal: 0,
        month: [0, 99],
        type: "",
        classroomId: "",
      },
      dialogForms: 1,
      typeOption: [
        {
          label: "月龄",
          value: 1,
        },
        {
          label: "等级",
          value: 2,
        }

      ],
      levelOption: EAllLevelOption(),
      classroomOption: this.getClassroomOption(),
      marks: {
        0: '0',
        30: '30',
        90: '90',

      },
      deleteParam: {

      },
      fcLessonName: "",//亲子业务别名
      allClassroom: [],
      subCardTypes: [],
    }
  },
  filters: {
    fitterLevelName(row) {
      let levelOp = EAllLevelOption();
      for (let i = 0; i < levelOp.length; ++i) {
        if (levelOp[i].value == row.levelVal) {
          return levelOp[i].label
        }
      }
    },
    fitterMaxLevelName(row) {
      let levelOp = EAllLevelOption();
      for (let i = 0; i < levelOp.length; ++i) {
        if (levelOp[i].value == row.maxLevelVal) {
          return levelOp[i].label
        }
      }
    }
  },
  created() {

  },
  mounted() {
    this.flechList();
    this.getOpenBookLevelLimit();
    this.getFcLessonName();
    this.getSubTypeList();
    this.lessons();
  },

  methods: {
    clikChange(){
      this.flechList();
    },
    dialogForm(val) {
      switch (val) {
        case 1: // 创建课程  // 编辑课程
          if (this.dialogForms == 1) {
            this.newLevel()
          } else {
            this.updateLeve()
          }
          break;
        case 2: // 取消
          this.countermand = false
          break;
        case 4: // 下线
          this.offLi()
          break;
        case 5: // 删除
          // this.course = false
          this.delLevel()
          break;
      }
    },
    // 下线
    offLi() {
      let param = {
        id: this.selectionList[0].id,
      }
      offLine(param).then((res) => {
        if (res.code == 20000) {
          messageUtils.successMsg(this, "课程下线成功")
          this.flechList();
          this.downline = false
        }
      })
    },
    //创建课程
    newLevel() {
      console.log(this.newLevelfrom,'this.newLevelfrom==')
      // return
      // this.newLevelfrom.levelName = '  '
      let param = {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        ...this.newLevelfrom
      }
      newLevelLesson(param).then((res) => {
        if (res.code == 20000) {
          messageUtils.successMsg(this, "课程创建成功")
          this.flechList();
          this.dialogFormVisible = false
        }
      })
    },
    //编辑课程
    updateLeve() {
      // this.newLevelfrom.levelName = '  '

      updateLevelLesson({ storeFrontId: globaldata.getAdminStore().storeFrontId, ...this.newLevelfrom }).then((res) => {
        if (res.code == 20000) {
          messageUtils.successMsg(this, "课程编辑成功")
          this.flechList();
          this.dialogFormVisible = false
        }
      })
    },
    // 删除
    delLevel() {
      let param = {
        id: this.selectionList[0].id,
      }
      delLevelLesson(param).then(response => {
        if (response.code == 20000) {
          messageUtils.successMsg(this, '删除成功');
          this.course = false
          this.flechList();
        }
      })
    },
    // 弹窗
    clickManage(val) {
      let self = this
      switch (val) {
        case 1: // 创建课程
          this.newLevelfrom = {
            levelName: '',
            serviceLessonId: '', // 业务类型
            type: 1,//类型
            startMonth: 0, //min月龄
            endMonth: 0, //max月龄
            levelVal: 0, // min等级
            maxLevelVal: 0,//max等级
            lessonName: '', //课程名称
            consumeNum: '', //消耗课时
          },
            this.lessons()
          this.dialogForms = 1
          this.dialogFormVisible = true

          break;
        case 2: // 取消
          this.countermand = true
          break;
        case 3: // 编辑课程
          if (self.selectionList && self.selectionList.length) {
            if (self.selectionList.length == 1) {
              this.dialogForms = 2
              self.lessons()
              self.newLevelfrom = self.selectionList[0]
              // self.$set(self.newLevelfrom,'type',JSON.stringify(self.newLevelfrom.type))
              // self.newLevelfrom.type = JSON.stringify(self.newLevelfrom.type)
              // self.newLevelfrom.serviceLessonId = Number(self.newLevelfrom.serviceLessonId)
              self.$nextTick(() => {
                self.dialogFormVisible = true
              })
            } else {
              self.$message.error('请选择一条数据');
            }
          } else {
            self.$message.error('请选择一条数据');
          }
          break;
        case 4: // 下线
        if(this.selectionList.length == 0 || this.selectionList.length>1){
        messageUtils.errorMsg(this, "请先选择一条信息");
        return 
      }
      this.selectRow = this.selectionList[0]
          this.downline = true
          break;
        case 5: // 删除
          if (self.selectionList && self.selectionList.length) {
            if (self.selectionList.length == 1) {
              self.course = true
            } else {
              self.$message.error('请选择一条数据');
            }
          } else {
            self.$message.error('请选择一条数据');
          }
          break;
      }
    },

    lessons() {
      let param = {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        storeTemplateId: 1,
        pageNum: 1,
        pageSize: 99999
      }
      lessonsList(param).then((res) => {
        if (res.code == 20000) {
          this.lessList = res.data.list
        }
      })
    },
    // getStoreLevelLesson(data){
    //
    //   this.refreshData(data);
    // },
    getType(type) {
      for (let i = 0; i < this.typeOption.length; ++i) {
        if (this.typeOption[i].value == type) {
          return this.typeOption[i];
        }
      }
      return null;
    },
    getSubTypeList() {
      let param = {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        storeLessonCardTemplateId: 1
      }
      this.subCardTypes = []
      getCardSubTypeList(param).then(response => {
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }
        for (let i = 0; i < data.length; ++i) {
          let option = {
            id: data[i].id,
            type: data[i].name,
          }
          this.subCardTypes.push(option);
        }

      })
    },
    flechList() {
      this.listLoading = true;
      //globaldata.getStoreLevelLesson(this.getStoreLevelLesson);

      let param = {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        serviceId: this.serviceName
      }
      qlStoreLevelLesson(param).then(response => {
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }
        this.totalPage = data.total;

        // data.forEach(item=>{
        //   item.classroomName = this.getClassroomById(item.classroomId )
        // });
        this.refreshData(data);

      })


      this.listLoading = false;
    },

    //点击查询按钮
    onBtnSearch() {
      this.flechList();
    },
    DETtnSearch(){
      this.serviceName = ''
      this.flechList();

    },
    //刷新页面数据
    refreshData(list) {
      if (commonUtils.isObjectNull(list)) {
        return;
      }
      this.tableData = [];
      for (let i = 0; i < list.length; ++i) {
        let typeDes = this.getType(list[i].type);
        if (typeDes == null) {
          typeDes = "无类型";
        } else {
          typeDes = typeDes.label;
        }
        let startMonthDes = '-';
        let endMonthDes = '-';
        let levelName = '  ';
        let maxLevelName = '-';
        if (list[i].type == 1) {
          startMonthDes = list[i].startMonth;
          endMonthDes = list[i].endMonth;
        } else if (list[i].type == 2) {
          levelName = list[i].levelName;
          maxLevelName = list[i].maxLevelName;
        }

        let data = {
          number: i + 1,
          id: list[i].id,
          lessonName: list[i].lessonName,
          consumeNum: list[i].consumeNum,
          levelName: levelName,
          maxLevelName: maxLevelName,
          levelVal: list[i].levelVal,
          maxLevelVal: list[i].maxLevelVal,
          startMonthDes: startMonthDes,
          isOffLine: list[i].isOffLine,
          serviceLessonId: list[i].serviceLessonId,
          endMonthDes: endMonthDes,
          startMonth: list[i].startMonth,
          endMonth: list[i].endMonth,
          type: list[i].type,
          classroomId: list[i].classroomId,
          classroomName: list[i].classroomName,
          typeDes: typeDes,
          cardSubTypeId: list[i].cardSubTypeId,
          serviceName: list[i].serviceName
        };
        this.tableData.push(data);


      }
    },
    handleDeleteOne(row) {
      this.$confirm('是否要删除课程名为：' + row.lessonName + ' 的课程?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',

      }).then(() => {
        let param = {
          id: row.id,
        }
        delLevelLesson(param).then(response => {
          let data = response.data;
          if (data == true) {
            messageUtils.successMsg(this, response.message);
            this.flechList();
          } else {
            messageUtils.errorMsg(this, response.message);
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    doUpdatePosition(t, dlg) {


    },
    selectionChange(val) {
      this.selectionList = val
      // console.log(val, '===============')
    },
    //添加
    handleCreateOneDlg() {
      this.visibleDlgAdd = true;
    },
    clickInput(val) {
      if (val == 2) {
        this.newLevelfrom.startMonth = 0
        this.newLevelfrom.endMonth = 0
      } else {
        this.newLevelfrom.levelVal = 0
        this.newLevelfrom.maxLevelVal = 0
      }
    },
    onChaneLevel(val) {
      for (let i = 0; i < this.levelOption.length; ++i) {
        if (this.levelOption[i].value == val) {
          this.createParam.levelName = this.levelOption[i].label
        }
      }
    },
    onChaneMaxLevel(val) {
      for (let i = 0; i < this.levelOption.length; ++i) {
        if (this.levelOption[i].value == val) {
          this.createParam.maxLevelName = this.levelOption[i].label
        }
      }
    },
    onChaneLevelUpdate(val) {
      for (let i = 0; i < this.levelOption.length; ++i) {
        if (this.levelOption[i].value == val) {
          this.updateParam.levelName = this.levelOption[i].label
        }
      }
    },
    onChaneMaxLevelUpdate(val) {
      for (let i = 0; i < this.levelOption.length; ++i) {
        if (this.levelOption[i].value == val) {
          this.updateParam.maxLevelName = this.levelOption[i].label
        }
      }
    },
    handleCreateOne() {

      let param = {
        lessonName: this.createParam.lessonName,
        levelName: this.createParam.levelName,
        levelVal: this.createParam.levelVal,
        maxLevelVal: this.createParam.maxLevelVal,
        startMonth: this.createParam.month[0],
        endMonth: this.createParam.month[1],
        type: this.createParam.type,
        consumeNum: this.createParam.consumeNum,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        classroomId: this.createParam.classroomId,
        cardSubTypeId: this.createParam.cardSubTypeId,
      }
      newLevelLesson(param).then(response => {
        let data = response.data;
        if (data == true) {
          messageUtils.successMsg(this, response.message);
          this.flechList();
          this.visibleDlgAdd = false;
        } else {
          messageUtils.errorMsg(this, response.message);
        }
      })
    },


    //修改
    handleUpdateOneDlg(row) {
      this.visibleDlgUpdate = true;
      let month = [row.startMonth, row.endMonth]
      this.updateParam = {
        id: row.id,
        lessonName: row.lessonName,
        levelName: row.levelName,
        maxLevelName: row.maxLevelName,
        levelVal: row.levelVal,
        maxLevelVal: row.maxLevelVal,
        month: month,
        type: row.type,
        consumeNum: row.consumeNum,
        classroomId: row.classroomId,
        cardSubTypeId: row.cardSubTypeId,
      }
    },
    handleUpdateOne() {

      let param = {
        id: this.updateParam.id,
        lessonName: this.updateParam.lessonName,
        levelName: this.updateParam.levelName,
        levelVal: this.updateParam.levelVal,
        maxLevelVal: this.updateParam.maxLevelVal,
        startMonth: this.updateParam.month[0],
        endMonth: this.updateParam.month[1],
        type: this.updateParam.type,
        consumeNum: this.updateParam.consumeNum,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        classroomId: this.updateParam.classroomId,
        cardSubTypeId: this.updateParam.cardSubTypeId,
      }
      updateLevelLesson(param).then(response => {
        let data = response.data;
        if (data == true) {
          messageUtils.successMsg(this, response.message);
          this.flechList();
          this.visibleDlgUpdate = false;
        } else {
          messageUtils.errorMsg(this, response.message);
        }
      })
    },

    getOpenBookLevelLimit() {
      let param = {
        storeFrontId: globaldata.getAdminStore().storeFrontId
      }
      getOpenBookLevelLimit(param).then(response => {
        let data = response.data;
        if (data != null) {
          this.isLevelLesson = data;
        }
      })
    },
    isLevelLessonChanged(val) {
      let param = {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        bOpen: val
      }
      setOpenBookLevelLimit(param).then(response => {
        let data = response.data;
        if (data == true) {
          this.isLevelLesson = val;
          messageUtils.successMsg(this, response.message);
        } else {
          this.isLevelLesson = !val;
          messageUtils.errorMsg(this, response.message);

        }
      })
    },

    onSetLessonNameShowDig() {
      this.visibleDlgSetLessonName = true;
    },
    onSetLessonName() {
      let param = {
        id: globaldata.getAdminStore().storeFrontId,
        lessonName: this.fcLessonName
      }
      setFcLessonName(param).then(response => {
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }
        if (data == true) {
          messageUtils.successMsg(this, response.message)
          this.visibleDlgSetLessonName = false;
        } else {
          messageUtils.errorMsg(this, response.message)
        }

      })

    },

    getFcLessonName() {
      let param = {
        id: globaldata.getAdminStore().storeFrontId,
      }
      getFcLessonName(param).then(response => {
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }
        this.fcLessonName = data;

      })
    },

    getClassroomOption() {
      return [
        { label: "111", value: 0, },
        { label: "222", value: 3, },
      ]
    }
  }
}
</script>

<style scoped>
.operate-container {
  border: 0px;
  border-radius: 8px;
}

.business {
  text-align: left;
}

.el-card__body {
  padding: 30px;
}

.table-container {
  border: 0px;
}

.manage {
  background-color: #fff;
  padding: 20px;
  text-align: right;
}

/deep/ .el-table .el-table__cell {
  padding: 0px;
}

/deep/ .el-table--enable-row-transition .el-table__body td.el-table__cell {
  padding: 12px 0;
}

/deep/ .el-table th.el-table__cell>.cell {
  /* width: 90%; */
  /* height: auto; */
  background: #ecf3fd;
  /* border-radius: 8px; */
}

/deep/ .el-table__header-wrapper .cell {
  line-height: 60px;
  color: #0d6fb8;
}

/deep/ .el-dialog--center {
  /* border: 2px solid #d0d0d0; */
  border-radius: 10px;
}

/deep/ .el-dialog__header {
  text-align: left;
  /* border-radius: 10px; */
  /* background: #f0f7ff; */
}

.el-select {
  width: 100%;
}

.el-form-item {
  text-align: left;
}
</style>




// WEBPACK FOOTER //
// src/views/my-store/lesson-level-setting/index.vue